export function isStandaloneBrowser() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (window.navigator as any).standalone
  )
}

export function isWebview() {
  const useragent = navigator.userAgent
  const rules = [
    'WebView',
    '(iPhone|iPod|iPad)(?!.*Safari/)',
    'Android.*(wv|.0.0.0)',
  ]
  const regex = new RegExp(`(${rules.join('|')})`, 'ig')
  return Boolean(useragent.match(regex))
}

export const isWechat = () =>
  navigator.userAgent.toLowerCase().includes('micromessenger')

export const isImToken = () =>
  navigator.userAgent.toLowerCase().includes('imtoken')

export const isCoinbaseBrowser = () => {
  // @ts-ignore
  const ethereum = window?.ethereum as
    | {
        isCoinbaseWallet?: boolean
        isCoinbaseBrowser?: boolean
      }
    | undefined
  return ethereum?.isCoinbaseBrowser
}

export const isTrust = () => {
  const w = window as any
  return !!w?.ethereum?.isTrust
}

export const isSnapchat = () =>
  navigator.userAgent.toLowerCase().includes('snapchat')

export const isLine = () => navigator.userAgent.toLowerCase().includes('line')
